/*
 * Copyright (c) Nexign, JSC, 2019-2022.
 */
/**
 *
 * @author Evgenij Tyan
 * @author Yakov Gushchin
 * @author Aleksandr Perkhunov
 * @author Ilya Babanov
 * @version 1.21.0
 * @since 1.0.0
 */

import { IAction, IActionWithPayload } from '@modules/app/createAction';

import { ILabelEditorLoadListPayload } from './labelEditorActions';
import {
    LABEL_EDITOR_CREATE,
    LABEL_EDITOR_CREATE_FAILED,
    LABEL_EDITOR_CREATE_SUCCESSFUL,
    LABEL_EDITOR_LOAD_LIST,
    LABEL_EDITOR_LOAD_LIST_FAILED,
    LABEL_EDITOR_LOAD_LIST_SUCCESSFUL,
    LABEL_EDITOR_SEARCH,
    LABEL_EDITOR_SWITCH,
    LABEL_EDITOR_UPDATE,
    LABEL_EDITOR_UPDATE_FAILED,
    LABEL_EDITOR_UPDATE_SUCCESSFUL,
} from './labelEditorConstants';

/**
 * @description Label props
 * @interface IEditableLabel
 * @property {boolean} checked - checked label
 * @property {number} id - label id
 * @property {string} color - label color
 * @property {string} name - label name
 */
export interface IEditableLabel {
    checked?: boolean;
    color?: string;
    id: number;
    name: string;
}

export enum EEditableLabel {
    mobile = 'MOBILE',
    subscriberId = 'SUBSCRIBER_ID',
}

/*
* -------------------------------------------
*          LOAD LABEL LIST
* -------------------------------------------
*/

export type TLabelEditorLoadListAction =
    IActionWithPayload<typeof LABEL_EDITOR_LOAD_LIST, ILabelEditorLoadListPayload>;

export type TLabelEditorLoadListSuccessfulAction =
    IActionWithPayload<typeof LABEL_EDITOR_LOAD_LIST_SUCCESSFUL, IEditableLabel[]>;

export type TLabelEditorLoadListFailedAction =
    IActionWithPayload<typeof LABEL_EDITOR_LOAD_LIST_FAILED, string>;

/*
* -------------------------------------------
*          CREATE LABEL
* -------------------------------------------
*/
export type TLabelEditorCreateAction =
    IActionWithPayload<typeof LABEL_EDITOR_CREATE, string>;

export type TLabelEditorCreateSuccessfulAction =
    IActionWithPayload<typeof LABEL_EDITOR_CREATE_SUCCESSFUL, IEditableLabel>;

export type TLabelEditorCreateFailedAction =
    IActionWithPayload<typeof LABEL_EDITOR_CREATE_FAILED, string>;

/*
* -------------------------------------------
*          UPDATE LABEL LIST
* -------------------------------------------
*/
export type TLabelEditorUpdatePayload = EEditableLabel;

export type TLabelEditorUpdateAction =
    IActionWithPayload<typeof LABEL_EDITOR_UPDATE, IEditableLabel[]>;

export type TLabelEditorUpdateSuccessfulAction =
    IAction<typeof LABEL_EDITOR_UPDATE_SUCCESSFUL>;

export type TLabelEditorUpdateFailedAction =
    IActionWithPayload<typeof LABEL_EDITOR_UPDATE_FAILED, string>;

/*
* -------------------------------------------
*          SEARCH LABEL
* -------------------------------------------
*/

export type TLabelEditorSearchAction =
    IActionWithPayload<typeof LABEL_EDITOR_SEARCH, string>;

/*
* -------------------------------------------
*          SWITCH LABELS
* -------------------------------------------
*/

export type TLabelEditorSwitchAction =
    IActionWithPayload<typeof LABEL_EDITOR_SWITCH, IEditableLabel[]>;
